import { usePrefetchV2, usePrefetch } from '../prefetch';
import { useHasCardV2 } from 'crm-object-board-core/hooks';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CrmObjectBoardPrefetchV2 = props => {
  usePrefetchV2(props);
  return null;
};
const CrmObjectBoardPrefetchV1 = props => {
  usePrefetch(props);
  return null;
};
export const CrmObjectBoardPrefetch = props => {
  const v2 = useHasCardV2();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [v2 && /*#__PURE__*/_jsx(CrmObjectBoardPrefetchV2, Object.assign({}, props)), !v2 && /*#__PURE__*/_jsx(CrmObjectBoardPrefetchV1, Object.assign({}, props))]
  });
};